/** @flow */

export const URL = 'soiltestresults/'
export const MODEL = 'SoilTestsResults'
export const TREE = 'soilTestResultData'
export const BRANCH = 'soilTestResults'

export const PROP_ID = 'id'
export const PROP_SOIL_TEST_RESULT_ID = PROP_ID
export const PROP_VIRTUAL_SOIL_TEST_INPUT = 'virtualSoilTestInput'
export const PROP_RECENGINE_CHECK = 'recengineCheck'
export const PROP_ZONE_NUMBER = 'zoneNumber'
export const PROP_GRID_POINT = 'gridPoint'
export const PROP_LAB_LOT_NUMBER = 'labLotNumber'
export const PROP_IS_VIRTUAL = 'isVirtual'
export const PROP_IS_TRANSFORMED = 'isTransformed'
export const PROP_DEPTH_DESCRIPTION = 'depthDescription'
export const PROP_MIN_DEPTH = 'minDepth'
export const PROP_MAX_DEPTH = 'maxDepth'
export const PROP_N = 'n'
export const PROP_P_OTHER = 'pOther'
export const PROP_P_BRAY = 'pBray'
export const PROP_P_OLSEN = 'pOlsen'
export const PROP_P_KELOWNA = 'pKelowna'
export const PROP_P_COLWELL = 'pColwell'
export const PROP_P_BSES = 'pBses'
export const PROP_P_MEHLICH = 'pMehlich'
export const PROP_P_RESIN = 'pResin'
export const PROP_P_STRONG_BRAY = 'pStrongBray'
export const PROP_P_TEST = 'pTest'
export const PROP_K = 'k'
export const PROP_K_CATION_SAT = 'k_cation_sat'
export const PROP_S = 's'
export const PROP_H = 'h'
export const PROP_H_CATION_SAT = 'h_cation_sat'
export const PROP_AL = 'al'
export const PROP_AL_CATION_SAT = 'al_cation_sat'
export const PROP_AL_SATURATION = 'al_saturation'
export const PROP_CA = 'ca'
export const PROP_CA_CATION_SAT = 'ca_cation_sat'
export const PROP_MG = 'mg'
export const PROP_MG_CATION_SAT = 'mg_cation_sat'
export const PROP_NA = 'na'
export const PROP_NA_CATION_SAT = 'na_cation_sat'
export const PROP_B = 'b'
export const PROP_CU = 'cu'
export const PROP_FE = 'fe'
export const PROP_MN = 'mn'
export const PROP_ZN = 'zn'
export const PROP_CL = 'cl'
export const PROP_EC = 'ec'
export const PROP_EC_RATIO = 'ec_ratio'
export const PROP_OM = 'om'
export const PROP_P_H = 'pH'
export const PROP_CEC = 'cec'
export const PROP_BASE_SAT = 'base_sat'
export const PROP_BUFFER_INDEX = 'buffer_index'
export const PROP_TOWNSHIP = 'township'
export const PROP__RANGE = '_range'
export const PROP_MERIDIAN = 'meridian'
export const PROP_SAMPLED_DATE = 'sampledDate'
export const PROP_ML_FLAG = 'mlFlag'
export const PROP_CCE = 'cce'
export const PROP_DEPTH_UNIT = 'depth_unit'
export const PROP_SAND = 'sand'
export const PROP_CLAY = 'clay'
export const PROP_SOIL_TEXTURE = 'soilTexture'
export const PROP_SPAW_P_W_P = 'spawPWP'
export const PROP_SPAW_F_C = 'spawFC'
export const PROP_SPAW_S_A_T = 'spawSAT'
export const PROP_SPAW_P_A_W = 'spawPAW'
export const PROP_SOURCE = 'source'
export const PROP_ZONE_MAP = 'zoneMap'
export const PROP_POINT_MAP = 'pointMap'
export const PROP_NEXT_RESULT = 'nextResult'
export const PROP_SOIL_SAMPLING_POINTS = 'soilSamplingPoints'
export const PROP_P = 'p'


export const DEPTH_DESCRIPTION_SURFACE = 'Surface'
export const DEPTH_DESCRIPTION_SUB_SURFACE = 'Subsurface'
export const DEPTH_DESCRIPTION_DEEP_SUB_SURFACE = 'Deep Subsurface'
export const DEPTH_DESCRIPTION_OPTIONS = [
  DEPTH_DESCRIPTION_SURFACE,
  DEPTH_DESCRIPTION_SUB_SURFACE,
  DEPTH_DESCRIPTION_DEEP_SUB_SURFACE,
]

export const P_TEST_P_OTHER = 'pOther'
export const P_TEST_P_BRAY = 'pBray'
export const P_TEST_P_OLSEN = 'pOlsen'
export const P_TEST_P_KELOWNA = 'pKelowna'
export const P_TEST_P_COLWELL = 'pColwell'
export const P_TEST_P_BSES = 'pBses'
export const P_TEST_P_MEHLICH = 'pMehlich'
export const P_TEST_P_RESIN = 'pResin'
export const P_TEST_OPTIONS = [
  P_TEST_P_OTHER,
  P_TEST_P_BRAY,
  P_TEST_P_OLSEN,
  P_TEST_P_KELOWNA,
  P_TEST_P_COLWELL,
  P_TEST_P_BSES,
  P_TEST_P_MEHLICH,
  P_TEST_P_RESIN,
]

export const DEPTH_UNIT_CENTIMETERS = 'Centimeters'
export const DEPTH_UNIT_INCHES = 'Inches'
export const DEPTH_UNIT_OPTIONS = [
  DEPTH_UNIT_CENTIMETERS,
  DEPTH_UNIT_INCHES,
]

export const LABEL_MIN_DEPTH = 'Min Depth'
export const LABEL_MAX_DEPTH = 'Max Depth'

export const SOIL_TEST_FILTER_ATTRIBUTES = [
  PROP_CEC, PROP_P_H, PROP_K_CATION_SAT,
  PROP_MG_CATION_SAT, PROP_CA_CATION_SAT,
  PROP_H_CATION_SAT, PROP_NA_CATION_SAT,
  PROP_OM, PROP_N, PROP_P, PROP_K, PROP_MG,
  PROP_CA, PROP_H, PROP_S, PROP_B, PROP_ZN,
  PROP_MN, PROP_FE, PROP_CU, PROP_NA,
]

export const SOIL_TEST_FILTER_OPTIONS = [
  {value: PROP_CEC, label: 'CEC'},
  {value: PROP_K_CATION_SAT, label: 'Base Sat (%K)'},
  {value: PROP_MG_CATION_SAT, label: 'Base Sat (%Mg)'},
  {value: PROP_CA_CATION_SAT, label: 'Base Sat (%Ca)'},
  {value: PROP_NA_CATION_SAT, label: 'Base Sat (%Na)'},
  {value: PROP_H_CATION_SAT, label: 'Base Sat (%H)'},
  {value: PROP_OM, label: 'OM'},
  {value: PROP_N, label: 'N (ppm)'},
  {value: PROP_P, label: 'P (ppm)'},
  {value: PROP_K, label: 'K (ppm)'},
  {value: PROP_S, label: 'S (ppm)'},
  {value: PROP_MG, label: 'Mg (ppm)'},
  {value: PROP_CA, label: 'Ca (ppm)'},
  {value: PROP_H, label: 'H'},
  {value: PROP_B, label: 'B (ppm)'},
  {value: PROP_ZN, label: 'Zn (ppm)'},
  {value: PROP_MN, label: 'Mn (ppm)'},
  {value: PROP_FE, label: 'Fe (ppm)'},
  {value: PROP_CU, label: 'Cu (ppm)'},
  {value: PROP_NA, label: 'Na (ppm)'},
  {value: PROP_P_H, label: 'pH'},
  {value: PROP_BUFFER_INDEX, label: 'Buffer Index'},
  {value: PROP_P_STRONG_BRAY, label: 'P Strong Bray (ppm)'},
  {value: PROP_P_BRAY, label: 'P Bray (ppm)'},
]

export const SOIL_TEST_TO_LAYER_MAP = {
  [PROP_EC_RATIO]: 'Electroconductivity Ratio',
  [PROP_ZN]: 'Zinc',
  [PROP_CA]: 'Calcium',
  [PROP_P_STRONG_BRAY]: 'P Bray (Strong)',
  [PROP_CA_CATION_SAT]: 'Ca Cation Saturation',
  [PROP_P_H]: 'pH',
  [PROP_CU]: 'Copper',
  [PROP_MIN_DEPTH]: 'Minimum Depth',
  [PROP_K_CATION_SAT]: 'K Cation Saturation',
  [PROP_P_BRAY]: 'P Bray',
  [PROP_MG_CATION_SAT]: 'Mg Cation Saturation',
  [PROP_CEC]: 'CEC',
  [PROP_OM]: 'Organic Matter',
  [PROP_FE]: 'Iron',
  [PROP_MG]: 'Magnesium',
  [PROP_B]: 'Boron',
  [PROP_P_OLSEN]: 'P Olsen',
  [PROP_NA_CATION_SAT]: 'Na Cation Saturation',
  [PROP_K]: 'Potassium',
  [PROP_MG]: 'Manganese',
  [PROP_N]: 'Nitrogen',
  [PROP_P]: 'Phosphorus',
  [PROP_S]: 'Sulphur',
  [PROP_NA]: 'Sodium',
  [PROP_MAX_DEPTH]: 'Maximum Depth',
  [PROP_EC]: 'Electroconductivity',
  [PROP_BUFFER_INDEX]: 'Buffer Index',
  [PROP_MN]: 'Manganese',
}
